import { useCallback } from 'react';
import { DisputeEventTypes } from 'enums';
import { useDisputeService } from 'services';
import { DisputeDocuments, useSetUploadedDocumentsList } from 'state';

export default function useUploadDocuments() {
    const disputeService = useDisputeService();
    const setUploadedDocumentsList = useSetUploadedDocumentsList();
    
    const uploadFiles = useCallback(async (disputeNumber: string = "", data: any, fileData: File[] ) => {
        const result = await disputeService.uploadDocuments(
            disputeNumber,{
            ...data,
            eventTypeId: DisputeEventTypes.DocumentAdded,
            isPublic: true
        }, 
        fileData);
        
        if (result.status) {

            const uploadedDocuments: DisputeDocuments = {
                disputeNumber: disputeNumber,
                documents: result.data
            }
            setUploadedDocumentsList(uploadedDocuments);
        } else {
            setUploadedDocumentsList(null);
        }

        return result;
    }, [disputeService, setUploadedDocumentsList]);

    const setNewDocuments = (newDocs: DisputeDocuments | null ) => setUploadedDocumentsList(newDocs);
    return {uploadFiles, setNewDocuments};
}